import { useEffect, useState } from "react";
import { TbArrowLeft, TbLock, TbShieldCheck } from "react-icons/tb";
import VerificationInput from "react-verification-input";
import { ValutDialog } from "../../../../Components/Molecules/ValutDialog";
import { Countdown } from "../../../../Components/Molecules";
import unlockPin from "../../../../Assets/Property 1=security success@2x.svg";
import { usePinContext } from "../../../../Contexts/PinContext";
import useCallAxios from "../../../../Hooks/useCallAxios";
import { useToast } from "../../../../Hooks/toast";
import { loadItem } from "../../../../Utils";
import { useAuth } from "../../../../Contexts/AuthContext";

const userId = loadItem("userId");

const STEP_TITLES = {
  initial: "Criar pin transacional",
  token: "Verificação em duas etapas",
  pin: "Criar pin",
};

const STEP_ICONS = {
  initial: <TbLock className="h-4 w-4" />,
  token: <TbShieldCheck className="h-4 w-4" />,
  pin: <TbLock className="h-4 w-4" />,
};

export const useModalPin = () => {
  const { addToast } = useToast();

  const [step, handleStep] = useState("initial");
  const [open, setOpen] = useState(false);
  const [pin, handlePin] = useState("");
  const [operatorId, handleOperatorId] = useState("");
  const [code, setcode] = useState("");
  const [verificationDisable, setVerificationDisable] = useState(false);
  const { isCreateRequiredPin, handleIsCreateRequiredPin } = usePinContext();

  const { user } = useAuth();

  const handleOpenModal = (id) => {
    setOpen(true);
    handleOperatorId(id);
  };

  const handleCloseModal = () => {
    handlePin("");
    setcode("");
    handleStep("initial");
    setOpen(false);
  };

  const {
    fetchPUT: createPinOperator,
    requestLoading: loadingCreatePinOperator,
    requestSuccess: SuccessCreatePinOperator,
  } = useCallAxios({ context: "operators" });

  const {
    fetchPOST: getTokenAuth,
    requestSuccess: SuccessGetTokenAuth,
  } = useCallAxios({ context: "getToken" });

  const onSubmit = () => {
    createPinOperator({
      id: userId,
      afterID: "pin",
      body: { pin, token: code },
    });
  };

  useEffect(() => {
    if (SuccessCreatePinOperator.PUT) {
      addToast({
        title: "Sucesso",
        description: "Pin criado com sucesso.",
        type: "success",
      });
      handleCloseModal();
      handleIsCreateRequiredPin();
    }
  }, [SuccessCreatePinOperator.PUT]);

  useEffect(() => {
    if (isCreateRequiredPin) {
      handleOpenModal();
    }
  }, [isCreateRequiredPin]);

  useEffect(() => {
    if (step === "token") {
      getTokenAuth({ headers: { Origin: "primebanco.valut.com.br" } });
    }
  }, [step]);

  return {
    open,
    pin,
    step,
    last_number: user.phone_number,
    code,
    loadingCreatePinOperator,
    handleCloseModal,
    setcode,
    handlePin,
    onSubmit,
    getTokenAuth,
    setVerificationDisable,
    handleStep,
  };
};

const ModalPin = () => {
  const {
    open,
    pin,
    step,
    last_number,
    code,
    loadingCreatePinOperator,
    handleCloseModal,
    setcode,
    handlePin,
    onSubmit,
    getTokenAuth,
    setVerificationDisable,
    handleStep,
  } = useModalPin();

  const renderFooter = () => {
    if (step === "initial") {
      return (
        <button
          type="button"
          className="btn-primary w-full sm:w-auto"
          onClick={() => handleStep("token")}
        >
          Começar
        </button>
      );
    }

    if (step === "token") {
      return (
        <>
          <button
            type="button"
            className="btn-back w-full sm:w-auto"
            onClick={() => handleStep("initial")}
          >
            <TbArrowLeft className="h-4 w-4" />
            Voltar
          </button>
          <button
            type="submit"
            form="modal-pin-token-form"
            className="btn-primary w-full sm:w-auto"
            disabled={code.length !== 6}
          >
            Avançar
          </button>
        </>
      );
    }

    return (
      <>
        <button
          type="button"
          className="btn-back w-full sm:w-auto"
          onClick={() => handleStep("token")}
        >
          <TbArrowLeft className="h-4 w-4" />
          Voltar
        </button>
        <button
          type="submit"
          form="modal-pin-create-form"
          className="btn-primary w-full sm:w-auto"
          disabled={pin.length !== 4 || loadingCreatePinOperator.PUT}
        >
          {loadingCreatePinOperator.PUT ? "Criando..." : "Criar pin"}
        </button>
      </>
    );
  };

  return (
    <ValutDialog
      open={open}
      onClose={handleCloseModal}
      title={STEP_TITLES[step]}
      icon={STEP_ICONS[step]}
      maxWidth="sm"
      disableBackdropClose
      footer={renderFooter()}
      bodyClassName="!py-5"
    >
      {step === "initial" ? (
        <div className="flex flex-col items-center gap-4 text-center">
          <p className="text-sm text-brand-dark dark:text-gray-100">
            Para que você consiga realizar transações, precisamos criar a sua senha
            transacional.
          </p>
          <img src={unlockPin} alt="" width={220} className="mx-auto" />
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Clique em <strong className="text-brand-dark dark:text-gray-200">Começar</strong>{" "}
            para cadastrar sua senha de 4 dígitos.
          </p>
        </div>
      ) : null}

      {step === "token" ? (
        <form
          id="modal-pin-token-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (code.length === 6) {
              handleStep("pin");
            }
          }}
          className="flex flex-col items-center gap-4 text-center"
        >
          <p className="text-sm text-brand-dark dark:text-gray-100">
            Para sua segurança, insira o código de verificação enviado para o número{" "}
            <span className="font-medium">{last_number}</span>.
          </p>
          <div className="custom-styles">
            <VerificationInput
              length={6}
              value={code}
              onChange={setcode}
              placeholder=""
              inputProps={{
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    e.currentTarget.form?.requestSubmit();
                  }
                },
              }}
            />
          </div>
          <Countdown
            expireTime={45}
            resendCode={getTokenAuth}
            isExpired={(isExpired) => {
              setVerificationDisable(isExpired);
            }}
          />
        </form>
      ) : null}

      {step === "pin" ? (
        <form
          id="modal-pin-create-form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="flex flex-col items-center gap-5"
        >
          <div className="flex h-24 w-24 items-center justify-center rounded-full bg-gray-50 text-[#e7a73f] dark:bg-gray-800">
            <TbLock className="h-10 w-10" />
          </div>
          <p className="text-center text-sm text-gray-500 dark:text-gray-400">
            Digite sua senha transacional de 4 dígitos.
          </p>
          <div className="custom-styles">
            <VerificationInput
              length={4}
              value={pin}
              onChange={handlePin}
              placeholder=""
              inputProps={{
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    e.currentTarget.form?.requestSubmit();
                  }
                },
              }}
            />
          </div>
        </form>
      ) : null}
    </ValutDialog>
  );
};

export default ModalPin;
